import { useState, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Button, ErrorBoundary, I18nProvider, ThemeProvider } from "@/design-system";
import { siteConfig } from "@/config/site";
import { createQueryClient } from "@/lib/query-client";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  const [queryClient] = useState(createQueryClient);

  return (
    <ThemeProvider theme={siteConfig.defaultTheme} mode="light">
      <I18nProvider messages={{ locale: siteConfig.locale, dir: siteConfig.direction }}>
        <ErrorBoundary
          fallback={(_error, reset) => (
            <main id="main-content" className="fatal-state">
              <h1>نمایش این بخش ممکن نیست</h1>
              <p>یک خطای پیش‌بینی‌نشده رخ داد. دوباره تلاش کنید.</p>
              <Button onClick={reset} icon="refresh-cw">
                تلاش دوباره
              </Button>
            </main>
          )}
        >
          <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </ErrorBoundary>
      </I18nProvider>
    </ThemeProvider>
  );
}
